export const enums = {
  "exact": 0,
  "contains": 1,
  "containsNot": 2,
  "notGuessed": 3,
  "typed" : 4
}

export const maxGuessLength = 5;
export const attempts = 6;
export const WORDLIST = "merged.json"
export const POSSIBLE_SOLUTIONS = "possible_words.json"
